/// <reference path="../../typings/createjs/createjs.d.ts" />
import Ground from "./family_tree/items/Ground";
import Injures from "./family_tree/items/Injures";
import User from "./family_tree/items/User";
import GenerateAllPositions from "./family_tree/GenerateAllPositions";
import {Family} from "./family_tree/Family";
import {Imap, Ilayer} from "./family_tree/Config";
import ArrayTools from "../lib/array/ArrayTools";

declare var toggleAjaxTimer: any;
declare var window:any;
export default class FamilyTree extends Family{

    constructor(default_url:string, url:string) {
		super(default_url, url);
		if ( document.getElementById('family_tree') === null ) {
			return;
		}
        if ( document.getElementById('family_tree').dataset.userid !== undefined ) {
            this.userId = parseInt(document.getElementById('family_tree').dataset.userid);
        }
		// this.popover.alpha = 0;

        this.loadGui((map:Imap) => {
            this.map = map;
            this.setLevelIndex(this.getStartItem());
            this.setLevelIds();
            this.map = this.sortFamily(this.map); //kiszedi a bgt... :D
            this.initCanvas();

			window.updateCanvas = () =>{
				this.stage.update();
			}
        });
    }

    private setLevelIds():void{
        this.map.layers = new GenerateAllPositions(this.getStartItem(), this.map.layers).get();
        var len:number = this.map.layers.length;
        while (len--) {
            var item = this.map.layers[len];
            item.itemNumber = this.foundLevelIdNumber(item.levelId);
        }
    }

    private foundLevelIdNumber(levelId:string):number{
        var ret:number = 0;
        for (var key in this.map.layers) {
            var item = this.map.layers[key];
            if ( item.levelId === undefined ) {
                continue;
            }
            if ( item.levelId !== null ) {
                if ( item.levelId.indexOf(levelId) === 0 ) {
                    ++ ret;
                }
            }
        }
        return ret;
    }

    private events(): void {

		// this.map_full_zoom.addEventListener('change', (e:any)=>{
		// 	e.preventDefault();
		// 	var scale:number = parseFloat(e.target.value) / 100;
		// 	this.stage.scaleX = scale;
		// 	this.stage.scaleY = scale;
		// }, false);

		this.stage.on("mousedown", (evt:any) => {
			this.stagePositons = {x: this.stage.x - evt.stageX, y: this.stage.y - evt.stageY};
		});

		this.stage.on("pressmove", (evt:any) => {
			if ( this.stageDragEnabled === true ) {
				this.stage.x = evt.stageX + this.stagePositons.x;
				this.stage.y = evt.stageY + this.stagePositons.y;
			}
		});
    }

    private addItemsToStage(): void {
        var bg_name:string = 'bg';
        if ( this.preload.getResult(bg_name) === undefined) {
            bg_name = 'default_bg';
        }
        this.ground = new Ground(<HTMLImageElement>this.preload.getResult(bg_name), this.canvas);
        this.ground.x = this.map.layers[0].x;
        this.ground.y = this.map.layers[0].y;
		this.scale = this.map.scale;

		var index:number = 0;
		var lastLevelIndex:number = null;
		var minLevelIndex:number = 0;
        var maxLevelIndex:number = 0;
		for (var key in this.map.layers) {
            var item = this.map.layers[key];

			if ( item.levelIndex !== undefined ) {
				if ( minLevelIndex > item.levelIndex) {
					minLevelIndex = item.levelIndex;
				}
				if ( maxLevelIndex < item.levelIndex) {
					maxLevelIndex = item.levelIndex;
				}
			}
        }
        var starterId:number = this.getStartItem().id;
        var starterX:number = null;

		for (let i = minLevelIndex; i <= maxLevelIndex; i++) {
			for (var key in this.map.layers) {
				var item = this.map.layers[key];
				if (item.properties !== undefined) {
					if (item.properties.type !== undefined) {
						if ( item.levelIndex === i ) {
							if ( item.levelIndex !== lastLevelIndex) {
								lastLevelIndex = item.levelIndex;
								index = 0;
							}
							++ index;

							var tempX = this.addMapItem(item, index, false, item.id === starterId?true:false);
                            if ( item.id === starterId ) {
                                starterX = tempX - this.canvas.width/2;
                            }
						}
					}
				}
			}
		}

        // set center from starter user
        // for (var key in this.current_map.item) {
		//     var temp:any = this.current_map.item[key];
		// 	if ( temp.id_key === starterId ) {
        //         starterX = item.x;
        //         console.log('starterItem!!!',item);
		// 	    break;
		// 	}
		// }

		for (var key in this.current_map.item) {
		    var temp:any = this.current_map.item[key];
			this.modifCouplePostion(temp);
		}


		for (var key in this.current_map.item) {
		    var temp:any = this.current_map.item[key];
            // modify firt line postiions
            if ( minLevelIndex === temp.levelIndex ) {
                this.setToChildrenCenterPositon(temp);
            }
            if (maxLevelIndex === temp.levelIndex) {
                this.setToParentCenterPositon(temp);
            }
		}
        console.log('starterX', starterX);
        var canvasCenter:number = this.canvas.width;
        var modifierX:number = starterX;
        for (var key in this.current_map.item) {
            var temp:any = this.current_map.item[key];
            temp.x -= modifierX;
            // this.zindexUpWhenOwenFamily(temp);
        }

		for (var key in this.current_map.item) {
		    var temp:any = this.current_map.item[key];
            // draw lines
			this.calcPositions(temp, 'addLines');
		}

        this.stage.addChild(this.ground);

        //set scale
        this.setScale();
    }

    private recalcPositionWhenNotCorrect():void{
        var wantToRecalc:boolean = false;
        for (var key in this.current_map.item) {
            var temp:any = this.current_map.item[key];
            if ( this.calcPositions(temp, 'reCalcPositionsWhenExsist') === true ) {
                wantToRecalc = true;
            }
        }
        if ( wantToRecalc === true ) {
            this.recalcPositionWhenNotCorrect();
        }
    }

    private setScale(): void {
		this.ground.bg.scaleX = this.scale;
        this.ground.bg.scaleY = this.scale;
    }

    private initCanvas(): void {
        this.canvas = <HTMLCanvasElement>document.getElementById('family_tree');
        this.canvas.style.background = '#F8F8F8';
        this.stage = new createjs.Stage(this.canvas);

		createjs.Touch.enable(this.stage);
		this.stage.enableMouseOver(10);
		this.stage.mouseMoveOutside = true; // keep tracking the mouse even when it leaves the canvas

        this.preload = new createjs.LoadQueue();
        this.preload.on("complete", this.handleFileComplete, this);
        this.preload.loadManifest(this.gui_objects);

    }

    private onEnterFrame(e: createjs.TickerEvent): void {
		this.ground.move();
        this.stage.update(e);
    }

    private handleFileComplete(e: createjs.Event): void {
        this.events();
        createjs.Ticker.setFPS(25);
		this.canvas.width = window.innerWidth;
		this.canvas.height = this.original_height;
		this.startGame();

    }

    private startGame(): void {
        createjs.Ticker.on('tick', (e: createjs.TickerEvent) => { this.onEnterFrame(e) });
        this.addItemsToStage();
        this.stage.update();
    }
}



// WEBPACK FOOTER //
// ./components/FamilyTree.ts